import request from "libs/request";

// 查询系统字典列表
export function sysDictFinds(data) {
  return request({
    url: "/login/dic.do",
    method: "POST",
    headers: {
      locker: new Date().getTime()
    },
    data: data
  });
}